import { hotels } from '../../../config/affiliates/hotels/trip/phuket';
import { Content } from '../../types';

const phuketFamilyHotelsContent: Content = {
  title: 'מלונות מומלצים למשפחות בפוקט',
  imageUrl:
    '/images/thailand/phuket-family-hotels/phuket-family-hotels-wide.jpg',
  introduction:
    'פוקט, האי הגדול בתאילנד, הוא אחד היעדים האהובים ביותר על משפחות ישראליות – ובצדק. שילוב של חופים עוצרי נשימה, פעילויות מגוונות, ואינספור מלונות ידידותיים למשפחות הופכים אותו לגן עדן אמיתי. כדי לעשות לכם סדר ולעזור לבחור את המלון המושלם, ריכזנו עבורכם את ההמלצות הכי חמות, מחולקות לפי אזורים מרכזיים באי.',
  sections: [
    {
      title: 'פטונג – חופשה שקטה ליד מרכז העניינים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Marriott Resort & Spa Merlin Beach',
          text: "מחפשים מקום שקט אבל גם קרוב להכל? מלון מריוט מרלין ביץ' ייתן לכם בדיוק את זה. המלון נמצא קרוב לאזור התוסס של פטונג, אבל מציע שקט ושלווה עם חוף ים פרטי, שלוש בריכות ענקיות, מועדון ילדים פעיל, וחדרי משפחה מרווחים. מושלם למי שרוצה לשלב מנוחה ופעילויות בלי להתרחק מכל הכיף.",
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> למלון שאטלים חינמיים מספר פעמים ביום לפטונג וחזור. מומלץ לשריין מקום מראש!',
          link: {
            url: hotels['marriott-merlin'],
            text: 'לחצו כאן ובדקו את Marriott Merlin Beach בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קמאלה – מושלם לילדים הקטנים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Sunwing Kamala Beach Resort',
          text: 'אם אתם נוסעים עם ילדים קטנים, סאנווינג קמאלה הוא בחירה מעולה. המלון ממוקם על חוף רגוע ומציע שלל מתקנים מותאמים למשפחות: בריכות רדודות, מגלשות מים קטנות, חדרי משחקים ופעילויות בידור יומיות. בנוסף, המסעדות במקום מציעות תפריטים מיוחדים לילדים. חוויה בטוחה, רגועה וכיפית לכל המשפחה.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> במרחק הליכה קצר מהמלון נמצאים דוכני אוכל ומזכרות רבים, שוק הלילה של קמאלה ופארק השעשועים Carnival Magic.',
          link: {
            url: hotels['sunwing-kamala'],
            text: 'לחצו כאן ובדקו את Sunwing Kamala Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קאטה – גן עדן למשפחות שאוהבות חופים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Katathani Phuket Beach Resort',
          text: 'חולמים על חופשה מול חוף מהמם? מלון קטאנטאני מחכה לכם על קו המים של חוף קטה נוי. כאן תמצאו מספר בריכות, מועדון ילדים מושקע, אזורי משחקים, חדרים משפחתיים נוחים ושלל פעילויות ימיות. זה המקום למי שרוצה חופשה רגועה, במיקום פשוט מושלם.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong>  למלון שני אגפים- האגף החדש "Thani wing" ובו חדרים שעברו שיפוץ והאגף הישן ״Bhuri wing" אשר נמצא קרוב לבריכות ומועדון הילדים. לשיקולכם!',
          link: {
            url: hotels['katathani'],
            text: 'לחצו כאן ובדקו את Katathani Phuket Beach Resort בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'OZO Phuket',
          text: 'למי שמחפש אווירה קצת יותר מודרנית וקלילה, מלון אוזו פוקט מציע חוויית אירוח מעוצבת ועדכנית. עם חדרים מודרניים למשפחות, בריכת שחייה גדולה עם מתחם לילדים, מועדון ילדים פעיל ומרחק קצרצר מהחוף ומשוק הלילה. זה ה-מלון למשפחות צעירות שאוהבות להיות בלב העניינים.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> החדרים יחסית קטנים כך שלמשפחה עם מספר ילדים מומלץ לקחת חדר משפחה עם דלת מקשרת.',
          link: {
            url: hotels['ozo-phuket'],
            text: 'לחצו כאן ובדקו את OZO Phuket בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'קארון',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Emerald Resort Karon – נופש משפחתי רגוע בלב קארון',
          text: 'מלון אמרלד בקארון (Emerald Resort Karon) הוא בחירה מצוינת למשפחות שמחפשות מיקום מרכזי אך שקט. המלון ממוקם במרחק הליכה קצרה מהחוף, ובסביבתו שפע מסעדות, חנויות ושווקים מקומיים. החדרים מרווחים ונקיים, וישנם גם חדרים משפחתיים עם דלת מקשרת. בריכת השחייה גדולה, עם אזור רדוד לילדים, ויש מועדון ילדים קטן עם פעילויות בשעות היום. השירות במקום חמים ואדיב, והמחיר נחשב משתלם מאוד ביחס לתמורה. מדובר באופציה נהדרת למשפחות שמעדיפות את האווירה הנינוחה של קארון על פני ההמולה של פטונג.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> במחירים כאלה משתלם מאוד לשדרג לחדר עם גישה לבריכה.',
          link: {
            url: hotels['emerald-karon'],
            text: 'לחצו כאן ובדקו את Emerald Resort Karon בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'לגונה – חופשה יוקרתית ורגועה',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Angsana Laguna Phuket',
          text: 'רוצים להרגיש על אי פרטי משלכם? במלון אנגסנה לגונה תחוו יוקרה אמיתית באווירה נינוחה. המלון כולל בריכות מרהיבות, מועדון ילדים מצוין, שלל פעילויות ספורט ימי וחדרים מרווחים – כל מה שצריך כדי ליהנות מחופשה מפנקת באמת.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> מלונות הלגונה עובדים בשיתוף פעולה זה עם זה, ומתאפשרת כניסה חינמית למתקני המלונות השונים.',
          link: {
            url: hotels['angsana-laguna'],
            text: 'לחצו כאן ובדקו את Angsana Laguna Phuket בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'מאי קאו – שלווה על קו המים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'Marriott Mai Khao Beach',
          text: 'אם החלום שלכם הוא חופשה שקטה מול חוף פראי, מלון מריוט מאי קאו הוא המקום בשבילכם. כאן תמצאו בריכות גדולות, מתחמי משחק לילדים, מועדון ילדים עשיר וחדרים משפחתיים רחבי ידיים – בדיוק מה שצריך כדי להירגע ולהתמלא באנרגיות.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> למלון שאטל חינמי מספר פעמים בשעה למרכז הקניות הסמוך.',
          link: {
            url: hotels['marriott-mai-khao'],
            text: 'לחצו כאן ובדקו את Marriott Mai Khao Beach בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'Anantara Vacation Club',
          text: 'למחפשים חופשה יוקרתית עוד יותר – מלון אננטרה ויקיישן קלאב מציע סוויטות ווילות מרווחות עם בריכות פרטיות, מועדון ילדים פעיל ומגוון פעילויות לכל המשפחה. אידיאלי למי שרוצה פרטיות, שקט וטבע, בלי להתפשר על רמת הפינוק.',
        },
        {
          subtitle: '',
          text: '<strong>💡טיפ קטן ששווה זהב:</strong> קרוב לשדה התעופה של פוקט, כך שמושלם ליומיים ראשונים לאחר נחיתה עם ילדים.',
          link: {
            url: hotels['anantara-vacation-club'],
            text: 'לחצו כאן ובדקו את Anantara Vacation Club בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
    },
    {
      title: 'לסיכום',
      type: 'text',
      content:
        'בין אם אתם מחפשים חופשה שקטה, פעילה, יוקרתית או קלילה – בפוקט תמצאו בדיוק את מה שמתאים למשפחה שלכם.<br /> כל שנותר הוא לבחור את האזור שהכי מדבר אליכם, לארוז בגדי ים, ולהתכונן לחופשה משפחתית בלתי נשכחת!<br /> <strong>נשמח לסייע לכם במציאת המלון המושלם לצרכים האישיים שלכם, פנו אלינו בעמוד צור קשר.</strong>',
      sectionLink: {
        url: '/contact',
        text: 'צור קשר לקבלת סיוע בבחירת המלון המושלם',
      },
    },
  ],
};

export default phuketFamilyHotelsContent;
